import React, { FC } from 'react';
import classNames from 'classnames';

import {
  ModalDto,
  ModifierOption,
  ProductDto,
  ProductModifierDto,
} from '../../../types/schema';
import DetailsModal from '../../global/DetailsModal';
import Counter from './Counter';

interface CounterModifierProps {
  modifier: ProductModifierDto;
  productDetails: ProductDto;
  toggleModifierOptionAction: (payload: {
    modifier: ProductModifierDto,
    option: ModifierOption,
    operation: 'ADD' | 'SUBTRACT'
  }) => void;
}

const CounterModifier: FC<CounterModifierProps> = function CounterModifier({
  modifier,
  modifier: {
    slug,
    options,
  },
  toggleModifierOptionAction,
}) {
  const renderModal = (modal?: ModalDto) => modal && (
    <span className="pdp-options__counter-modifier-modal-wrapper">
      <DetailsModal
        teaserCopy={modal.teaserCopy}
        teaserIcon={modal.teaserIcon}
        salesTiers={modal.salesTiers}
        popUpCopy={modal.copy}
        header={modal.header}
        footnote={modal.footnote}
        asset={modal.assets && modal.assets[0]}
        links={modal.links}
      />
    </span>
  );

  const renderCounter = (option: ModifierOption) => (
    <div key={`${option.quantity}-${option.value}`} className="pdp-options__counter-modifier-wrapper">
      <div className="pdp-options__counter-modifier-container">
        <Counter
          count={option.count || 0}
          maxCount={option.maxQuantity ?? undefined}
          onAddClick={() => toggleModifierOptionAction({ modifier, option, operation: 'ADD' })}
          onSubtractClick={() => toggleModifierOptionAction({ modifier, option, operation: 'SUBTRACT' })}
        />
        <div className="pdp-options__counter-modifier-label">
          <span>{option.description}</span>
          {option.priceAdjust && (
            <span className="pdp-options__counter-modifier-price">
              {` +\xa0$${+option.priceAdjust * (option.count || 1)}`}
            </span>
          )}
          {option.modals && renderModal(option.modals[0])}
        </div>
      </div>
    </div>
  );

  return (
    <div className={classNames('pdp-options', slug)}>
      <div className="pdp-options-wrapper pdp-options-wrapper__column">
        {options.map(renderCounter)}
      </div>
    </div>
  );
};

export default CounterModifier;
